import { marketGrowthLegacyRedirectEntries } from "./slnRouteEntries.js";

/** Legacy /admin/market-growth/* -> /SLN/MarketGrowth/* redirects */
export default marketGrowthLegacyRedirectEntries[0];
